import React, { useState } from "react";
import { listItemDragProps } from "utils/drag";
import { Draggable } from "react-beautiful-dnd";
import SelectOption from "./option";
import { useHoverProps } from "utils/hooks";
import Grip from "components/Grip";
import classnames from "classnames";

// Select > DraggableOptionItem > FieldListItem
const FieldListItem = (props) => {
  const [hover, setHover] = useState();
  const hoverProps = useHoverProps({ hover, setHover });
  const extraProps = props.draggable ? hoverProps : {};
  const containerProps = {
    className: classnames(
      "flex flex-column w-100 relative bg-white relative overflow-hidden",
      {
        "ba br2 hairline-1 ph3 pt2 pb3 mb3": props.advanced,
        "pl3 pr2 pv1 mb2": !props.advanced
      }
    ),
    ...extraProps
  };

  return (
    <div {...containerProps}>
      {props.draggable && <Grip hover snapshot={props.snapshot} />}
      <SelectOption {...props} />
    </div>
  );
};

const DraggableOptionItem = (props) => (
  <Draggable
    isDragDisabled={props.dragDisabled}
    key={`${props.uid}-${props.index}`}
    draggableId={props.uid}
    index={props.index}
  >
    {(provided, snapshot) => (
      <li {...listItemDragProps(provided)}>
        <FieldListItem
          {...props}
          draggable={!props.dragDisabled}
          snapshot={snapshot}
        />
      </li>
    )}
  </Draggable>
);

export default DraggableOptionItem;
